<template>
  <div id="retroship">
    <div class="retro_mainwrap">
      <img class="retro_pc" src="../assets/img/retro_ship/retro_main.gif" alt="">
      <img class="retro_m" src="../assets/img/retro_ship/retro_main_m.gif" alt="">
      </div>
      <img class="retro_m" src="../assets/img/retro_ship/retro_mobile.jpg" alt="">
     <div class="retro_sec1 retro_pc">
        <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>

        <div class="retro_pc">
          <img src="../assets/img/retro_ship/retro_sec1.jpg" alt="">
        </div>

        <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div> 
     <div class="retro_sec2 retro_pc">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec2.jpg" alt="">
      <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div>
     <div class="retro_sec3 retro_pc">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec3.jpg" alt="">
      <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div>
     <div class="retro_sec4 retro_pc">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec4.jpg" alt="">
      <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div>
     <div class="retro_sec5 retro_pc">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec5.jpg" alt="">
      <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div>
     <div class="retro_sec6 retro_pc">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec6.jpg" alt="">
      <div class="retro_pc">
          <img src="../assets/img/retro_ship/retroline.jpg" alt="">
        </div>
     </div>
     <div class="retro_sec7">
      <img class="retro_pc"  src="../assets/img/retro_ship/retro_sec7.jpg" alt="">
          <a class="retrobutton" href="javascript:void(0)" @click="goToDetail('T-2512349HPC','T')">
            <img src="../assets/img/retro_ship/retrobutton.jpg" alt="">
          </a>
     </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
    }
  },

  mounted() {
  },


  methods: {
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    }
  },
}
</script>


<style scoped>
#retroship{ margin-top: -56px;
}
.retro_mainwrap {
  margin: 0 auto;
  max-width: 2000px;
  height: 1000px;
}
.retro_sec1 {
  margin: 0 auto;
  max-width: 2000px;
  height: 761px;
}
.retro_sec2 {
  margin: 0 auto;
  max-width: 2000px;
  height: 707px;
}
.retro_sec3 {
  margin: 0 auto;
  max-width: 2000px;
  height: auto;
}
.retro_sec4 {
  margin: 0 auto;
  max-width: 2000px;
  height: auto;
}
.retro_sec5 {
  margin: 0 auto;
  max-width: 2000px;
  height: auto;
}
.retro_sec6 {
  margin: 0 auto;
  max-width: 2000px;
  height: auto;
}
.retro_sec7 {
  margin: 0 auto;
  max-width: 2000px;
  height: auto;
}
.retrobutton{
  margin: 100px auto;
  display: block;
  width: 600px;
  height: 80px;
  transition: all 0.2s;
  border-radius: 10px;
}
.retrobutton:hover{
  transform: scale(1.05);
}
.retrobutton img{
  width: 100%;
}
.retro_sec1 img{
  text-align: center;
}
.retro_m{
  display: none;
}

@media(max-width:1024px){
  #retroship{ margin-top: 2rem;
}
  .retro_m{
    display: block;
    width: 100%;
  }
  .retro_pc{
    display: none;
  }
  .retro_mainwrap {
  height: auto;
}
.retrobutton{
   margin: 0px auto 50px auto;
   width: 80%;
   margin-top: 25px;
}
}


</style>
